import { TABLES } from "../db";
import { BaseLocalRepository } from "./BaseLocalRepository";

export class LocalVesselRepository extends BaseLocalRepository {
  constructor(db) {
    super(db, TABLES.VESSELS);
  }

  async listByOrganizationId(organizationId) {
    return this.table.where("organizationId").equals(organizationId).toArray();
  }
}
